// Fix links that open in a new tab
document.querySelectorAll('a[target="_blank"]').forEach(($link) => {
  $link.setAttribute('rel', 'noopener')
  $link.setAttribute('aria-label', `${$link.textContent} (opens in a new tab)`)
})

// Fix iRESTORE red color

window.toggleHigherContrast = () => {
  const higherContrastSetting = localStorage.getItem('higher-contrast')
  if (higherContrastSetting === 'true') {
    localStorage.setItem('higher-contrast', 'false')
    window.location.reload()
  } else {
    window.setHigherContrast()
  }
}

window.setHigherContrast = () => {
  console.log('Setting higher contrast')

  // This applies an override of the --irestore-red color in the theme.css file
  document.documentElement.classList.add('higher-contrast')

  /*
   Check if the stylesheet is internal or hosted on the current domain.
   If it isn't, attempting to access sheet.cssRules will throw a cross origin error.
   See https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleSheet#Notes
   
   NOTE: One problem this could raise is hosting stylesheets on a CDN with a
   different domain. Those would be cross origin, so you can't access them.
  */
  const isSameDomain = (styleSheet) => {
    // Internal style blocks won't have an href value
    if (!styleSheet.href) {
      return true
    }

    return styleSheet.href.indexOf(window.location.origin) === 0
  }

  /*
   Determine if the given rule is a CSSStyleRule
   See: https://developer.mozilla.org/en-US/docs/Web/API/CSSRule#Type_constants
  */
  const isStyleRule = (rule) => rule.type === 1

  ;[...document.styleSheets].filter(isSameDomain).forEach((sheet) => {
    ;[...sheet.cssRules].filter(isStyleRule).forEach((rule) => {
      ;[...rule.styleMap.entries()].forEach(([propName, propVal]) => {
        if (propName.indexOf('--') !== 0) return

        if (typeof propVal[0][0] === 'string' && propVal[0][0]?.toUpperCase() === '#F23440') {
          // console.log(rule, propName, propVal);
          rule.styleMap.set(propName, '#DE0D1B')
        } else if (typeof propVal[0][0] === 'string' && propVal[0][0]?.replace(' ', '') === '242,52,64') {
          // console.log(rule, propName, propVal);
          rule.styleMap.set(propName, '222, 13, 27')
        }
      })
    })
  })

  // Set the localStorage value so we can persist the setting
  localStorage.setItem('higher-contrast', 'true')

  const $accessibilityToggle = document.querySelector('#accessibility-toggle')
  if ($accessibilityToggle) {
    $accessibilityToggle.setAttribute('aria-checked', 'true')
  }
}

const higherContrastSetting = localStorage.getItem('higher-contrast')

if (window.matchMedia('(prefers-contrast: high)').matches || higherContrastSetting === 'true') {
  window.setHigherContrast()
}
